// constants.ts

export const APP_NAME = 'SHACLens';

// Other constants
export const CSV_EDGE_NOT_IN_ONTOLOGY_SHORTCUT_STRING = '-';
export const CSV_EDGE_NOT_IN_ONTOLOGY_STRING = 'EdgeNotPresent';
export const APP_HEADER_HEIGHT_PX = 50;
export const MANTINE_HEADER_COLOR = '#3B3B3F';
export const SPINNER_COLOR = MANTINE_HEADER_COLOR;
export const MISSING_EDGE_COLOR = '#d3d3d3';

// Default Node Colors
export const UNSELECTED_DEFAULT_COLOR = '#aaa';
export const SELECTED_DEFAULT_COLOR = '#aaa';

// Text Colors
export const SELECTED_TEXT_COLOR = 'black';
export const UNSELECTED_TEXT_COLOR = 'grey';

// Type Node Colors
export const SELECTED_TYPE_NODE_COLOR = '#007C45';
export const UNSELECTED_TYPE_NODE_COLOR = '#007C45'; // desaturated version

// Violation Node Colors
export const SELECTED_VIOLATION_NODE_COLOR = '#669900';
export const UNSELECTED_VIOLATION_NODE_COLOR = '#669900';

// Exemplar Node Colors
export const SELECTED_EXEMPLAR_NODE_COLOR = '#DA5700';
export const UNSELECTED_EXEMPLAR_NODE_COLOR = '#DA5700'; // desaturated version

// TODO Cumulative Number of Selected/Violating Node Colors
export const SELECTED_CUMULATIVE_NODE_COLOR = '#DA5700';
export const UNSELECTED_CUMULATIVE_NODE_COLOR = '#DA5700'; // desaturated version

// children/parent alignment constants
export const NODE_LAYOUT_OFFSET_X = 500;
export const DISTANCE_BETWEEN_NODES_Y = 70;

// tree layout constants
export const UNFOLDED_SUBTREE_BOUNDING_BOX_MARGIN = 100;
